export const eventsRoutes = (root: string) => ({
  root,
  view: () => {
    return `${root}/:eventId`;
  },
  vibrationEvents: () => {
    return `${root}/vibration-events`;
  },
});
